// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1vb0i","label":"Section_label__25Od5","contentWrap":"Section_contentWrap__2YaJg","footer":"Section_footer__1jhLp","footerInner":"Section_footerInner__3tfVN"};